export enum JobType {
  GENERAL,
  INSPECTION,
  ISSUE,
  MAINTENANCE,
  WORK_ORDER,
  MILL_ORDER,
}

export enum JobLabelType {
  GENERAL = 'General',
  ISSUE = 'Issue',
  INSPECTION = 'Inspection',
  WORK_ORDER = 'Purchase order',
  MAINTENANCE = 'Maintenance',
  MILL_ORDER = 'Mill order'
}

export enum JobIconType {
  GENERAL = 'mdi-account-hard-hat-outline',
  ISSUE = 'mdi-alert-box-outline',
  INSPECTION = 'mdi-magnify',
  WORK_ORDER = 'mdi-package-variant-closed',
  MAINTENANCE = 'mdi-hammer-wrench',
  MILL_ORDER = 'mdi-cog-outline'
}
